// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610051635/js/" + chunkId + "." + {"44":"e5b25271","225":"b03109b5","481":"d3cf8ad7","486":"d3a6b6cf","770":"e96faa2e"}[chunkId] + ".0.20167032408371666.chunk.js";
};